const ICONS = {
  LIKE: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z"/></svg>`,
  DISLIKE: `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 14V2"/><path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z"/></svg>`,
};

export function createBalloonLayout(ymaps: any, map: any) {
  // Создаем класс макета через API Яндекса
  const Layout = ymaps.templateLayoutFactory.createClass(
    `
    <div class="traffic-balloon" data-report-id="{{properties.reportId}}">
      
      <div class="traffic-balloon-content">
        {% if properties.imageUrl %}
          <div class="traffic-balloon-img-wrapper">
             <img src="{{properties.imageUrl}}" alt="Фото" class="traffic-balloon-img">
          </div>
        {% endif %}
        
        <p class="traffic-balloon-comment">
           {{properties.comment|default:"Нет описания"}}
        </p>
      </div>

      <div class="traffic-balloon-actions">
        <button type="button" 
          data-action="confirm" 
          class="traffic-btn {% if properties.userVoteType == 'LIKE' %}liked{% endif %}"
        >
          ${ICONS.LIKE}
          <span>{{properties.likeCount|default:0}}</span>
        </button>

        <div class="traffic-separator"></div>

        <button type="button" 
          data-action="outdated" 
          class="traffic-btn {% if properties.userVoteType == 'DISLIKE' %}disliked{% endif %}"
        >
          ${ICONS.DISLIKE}
          <span>{{properties.dislikeCount|default:0}}</span>
        </button>
      </div>

      <div class="traffic-balloon-footer">
        {{properties.authorName}} • {{properties.time}}
      </div>
    </div>
    `,
    {
      build: function () {
        // @ts-ignore
        this.constructor.superclass.build.call(this);
        // @ts-ignore
        this._onClick = this.onBalloonClick.bind(this);

        // @ts-ignore
        const el = this.getParentElement().querySelector('.traffic-balloon');
        if (el) {
          el.addEventListener('click', (this as any)._onClick);
        }
      },

      clear: function () {
        // @ts-ignore
        const el = this.getParentElement().querySelector('.traffic-balloon');
        if (el) {
          el.removeEventListener('click', (this as any)._onClick);
        }
        // @ts-ignore
        this.constructor.superclass.clear.call(this);
      },

      onBalloonClick: function (e: any) {
        const btn = e.target.closest('button');
        if (!btn) return;

        const action = btn.getAttribute('data-action');
        if (!action) return;

        e.preventDefault();
        // Важно остановить всплытие, чтобы карта не ловила клик
        e.stopPropagation();

        const root = btn.closest('.traffic-balloon');
        const reportId = root?.getAttribute('data-report-id');

        if (reportId) {
          map.events.fire('customballoonaction', {
            data: { reportId, action },
          });
        }
      },
    },
  );

  return Layout;
}
